import { render, staticRenderFns } from "./Brokeree.vue?vue&type=template&id=60592ab2"
import script from "./Brokeree.vue?vue&type=script&lang=js"
export * from "./Brokeree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports